var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "mr-3 flex flex-col items-center text-sm mb-1 slot__container",
      class: ["contentStyles", { "with-right-border": _vm.extend }],
    },
    [
      _c(
        "span",
        {
          staticClass: "font-normal text-low-xs text-primary-black",
          class: _vm.contentStyles,
        },
        [_c("span", [_vm._v(_vm._s(_vm.contentData))])]
      ),
      _c("span", { staticClass: "text-primary-500 mr-1 h-5" }, [
        _c(
          "p",
          {
            staticClass:
              "flex font-400 leading-6 mb-2 min-w-24 text-22 mb-1 text-storm-gray w-max-content",
          },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }